import type { SaleConfiguration } from "~/fragments/saleConfigurations"

/**
 * A box using the plan-input-counter mechanism (multiple SaleConfiguration
 * entries, one per quantity step, selected via `planInputLabel`) — a
 * different multi-plan mechanism from AX Configuration period switching.
 * Shared by ProductBoxWithSaleConfiguration and isProductBoxVisibleForPeriod
 * so the two stay in sync; duplicating this gate risked one recognizing a
 * box as plan-input-counter while the other didn't.
 */
export function isPlanInputCounterBox(
  saleConfiguration: SaleConfiguration[],
  planInputLabel?: string
): boolean {
  return Boolean(planInputLabel) && saleConfiguration.length > 1
}
